//v1.0
//Loader base class for all loaders
export interface ProgressObject {
	id: string;
	ratio: number;
	total?: number;
	loaded?: number;
}

export abstract class Loader {
	public id: string;
	public onProgress: Function;
	public onComplete: Function;
	public onError: Function;
	public onAssetLoaded: Function;

	protected onGroupAssetComplete: Function;
	protected onGroupError: Function;

	protected _complete: boolean = false;

	public load(): void {}

	public destroy(): void {
		return;
		this.onProgress = null;
		this.onComplete = null;
		this.onError = null;
		this.onGroupAssetComplete = null;
		this.onGroupError = null;
	}

	public getTotalAssets(): number {
		return 1;
	}

	public getLoadedAssets(): number {
		return this._complete ? 1 : 0;
	}

	//LoaderGroup needs to manage callbacks on its own so it doesn't
	public setLoaderGroupCallbacks(assetComplete: Function, error: Function): void {
		this.onGroupAssetComplete = assetComplete;
		this.onGroupError = error;
	}

	//protected
	//--------------------------------------------------------
	//--------------------------------------------------------
	//--------------------------------------------------------
	//--------------------------------------------------------

	protected complete(data: any = null): void {
		this._complete = true;

		if (this.onComplete) {
			this.onComplete(data, this);
		}

		if (this.onGroupAssetComplete) {
			this.onGroupAssetComplete(data, this);
		}
	}

	protected assetLoaded(data: any = null): void {
		if (this.onAssetLoaded) {
			this.onAssetLoaded(data, this);
		}
		if (this.onGroupAssetComplete) {
			this.onGroupAssetComplete(data, this);
		}
	}

	protected progress(data: ProgressObject): void {
		if (this.onProgress) {
			this.onProgress(data, this);
		}
	}

	protected error(error: string): void {
		if (this.onError) {
			this.onError(error, this);
		}
		if (this.onGroupError) {
			this.onGroupError(error, this);
		}
	}
}
